import React, { FC } from 'react';
import { Form, FormItemProps } from '@oscar/theme';

export interface FieldProps extends FormItemProps {}

export interface CustomFieldProps extends FieldProps {
  dependencies?: string[];
}

const Field: FC<FieldProps> = ({ children, ...props }) => {
  return <Form.Item {...props}>{children}</Form.Item>;
};

export default Field;
